module.exports = __webpack_public_path__ + "static/media/leslogo.7ddfc787.svg";